import { Link } from "react-router-dom";

export default function AboutHero() {
  return (
    <section className="relative w-full overflow-hidden" style={{ height: "70vh", minHeight: "550px" }}>
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://images-pw.pixieset.com/site/BAJyQr/qLrdZ4/pkheadshotwcamera-004103a6-1500.jpeg"
          alt="Stephanie — Precious Keepsakes Photography San Antonio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-transparent" />
      </div>
      <div className="relative z-10 flex flex-col justify-center h-full px-8 md:px-20">
        <nav className="flex items-center gap-2 mb-6 text-white/50 font-sans text-xs tracking-widest uppercase">
          <Link to="/" className="hover:text-pk-gold transition-colors cursor-pointer">Home</Link>
          <span>/</span>
          <span className="text-pk-gold">About</span>
        </nav>
        <div className="flex items-center gap-4 mb-4">
          <div className="w-8 h-px bg-pk-gold" />
          <span className="font-sans text-xs tracking-widest3 uppercase text-pk-gold">Meet the Photographer</span>
        </div>
        <h1 className="font-display text-6xl md:text-8xl font-light text-white leading-tight max-w-2xl">
          Hey, I&apos;m<br /><em className="font-medium">Stephanie</em>
        </h1>
        <p className="font-display text-xl italic text-white/70 mt-5 max-w-lg leading-relaxed">
          Fine art photographer. Connection seeker. Memory keeper.
        </p>
        <Link
          to="/services"
          className="mt-10 inline-block bg-pk-gold text-white font-sans text-sm tracking-widest uppercase px-10 py-4 rounded-sm hover:bg-white hover:text-pk-charcoal transition-colors duration-300 whitespace-nowrap cursor-pointer w-fit"
        >
          Work With Stephanie
        </Link>
      </div>
    </section>
  );
}